<template>
<div class="wiki_history" id="kb_edit_history"></div>
</template>

<script lang="ts">
import { TocaHistoryEditor, type DocInfo } from '@toca/toca-edit';

import { mapState, mapActions } from 'vuex';
export default {
    name: 'wiki_history',
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState({
            doc_id: state => state.kbModule.doc_id,
            userInfo: state => state.userModule,
            doc_info: state => state.kbEditModule.doc_info,
            treeNodes: state => state.kbTreeNodeModule.treeNodes,
            wikiI18n: (state: any) => state.kbModule.wikiI18n
        })
    },
    methods: {
        ...mapActions({
            setDocView: 'kbModule/setDocView'
        }),
        // 获取文件树节点
        _findTreeNode(fileId, treeNodes) {
            if (!treeNodes || !fileId) return null;
            let treeNode = null;
            for (let i = 0; i < treeNodes.length; i++) {
                if (treeNodes[i].fileId === fileId) {
                    treeNode = treeNodes[i];
                    break;
                } else {
                    if (
                        treeNodes[i].children &&
                        treeNodes[i].children.length > 0
                    ) {
                        treeNode = this._findTreeNode(
                            fileId,
                            treeNodes[i].children
                        );
                        if (treeNode) break;
                    }
                }
            }
            return treeNode;
        },
        _fixedDocInfo() {
            let docInfo = this.doc_info;
            let newDocInfo: DocInfo = {};
            if (docInfo.fileInfo) {
                newDocInfo.creator =
                    this._findTreeNode(docInfo.fileInfo?.fileId, this.treeNodes)
                        ?.creator ?? {};
                newDocInfo.auth = docInfo.fileInfo?.auth ?? '';
                newDocInfo.fileName = docInfo.fileInfo?.fileName ?? '';
                newDocInfo.createTime = docInfo.fileInfo?.createTime ?? 0;
            }
            return {
                ...docInfo,
                ...newDocInfo
            };
        }
    },
    mounted() {
        this.tocaHistoryEditor = new TocaHistoryEditor('#kb_edit_history', {
            fileId: this.doc_id,
            env: import.meta.env.MODE,
            onBackFunc: html => {
                this.setDocView('home');
                if (html) {
                    window['editor']?.commands?.clearContent();
                    window['editor']?.commands?.setContent(html, true);
                    window['editor'].view.needRefreshSync = true;
                }
            },
            showWaterMark: true,
            userInfo: this.userInfo,
            docInfo: this._fixedDocInfo(),
            locale: this.wikiI18n
        });
    }
};
</script>

<style lang="scss" scoped>
.wiki_history {
    width: 100%;
}
</style>
